import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Organizacion } from "./configuracionGeneral/organizacion";
import { Personas } from "./configuracionGeneral/personas";
import { Usuario } from "./configuracionGeneral/usuarios";
import { Petro } from "./configuracionGeneral/valorpetro";
import { UTE } from "./configuracionGeneral/valorute";
import { UsuarioWeb } from "./configuracionGeneral/usuariosWeb";
import { UsuariosApp } from "./configuracionGeneral/usuariosApp";
import { PorcentajeUTE } from "./configuracionGeneral/valoruteporcentaje";
import EstructOrganizativa from "./configuracionGeneral/tablaPestructuraOrg";
import CambiarEfiscal from "../catalogos/catalogoCambiarEfiscal";
import { DolarBcv } from "./configuracionGeneral/valordolarbcv";
import { TimbreActu } from "./configuracionGeneral/TimbreActu";
import GenerarBackup from "./configuracionGeneral/generarBackup";
import { ver } from "../util/varios";
import GestionarScript from "./configuracionGeneral/gestionDataScript";

export const VerConfiguracion = (props) => {
  const [mostrar, setMostrar] = useState(0);
  const [clase, setClase] = useState("d-flex bluex-bg");
  const [mostrar1, setMostrar1] = useState(false);
  const [accconfigene, setAccconfigene] = useState(
    JSON.parse(localStorage.getItem("accconfigene"))
  );

  const estilos = {
    color: "#1d0345",
    backgroundColor: "transparent",
  };

  const VISTA = {
    0: <Organizacion />,
    1: <Personas />,
    2: <Usuario />,
    3: <Petro />,
    /*     4: <DolarBcv />,
    5: <UTE />,
    6: <PorcentajeUTE />, */
    4: <UsuarioWeb />,
    5: <UsuariosApp />,
    6: <EstructOrganizativa />,
    7: <TimbreActu />,
    8: <GenerarBackup />,
    9: <GestionarScript />,
  };

  const ICONO = {
    0: <i className="fas fa-sitemap fa-fw me-3 text-orange px-2" />,
    1: <i className="fas fa-user-alt fa-fw me-3 text-primary px-2" />,
    2: <i className="fas fa-user-check fa-fw me-3 text-success px-2" />,
    3: <i className="fas fa-university fa-fw me-3 text-info px-2" />,
    /*     4: <i className="fas fa-university fa-fw me-3 text-info px-2" />,
    5: <i className="fas fa-chart-line fa-fw me-3 text-warning px-2" />,
    6: <i className="fas fa-chart-line fa-fw me-3 text-primary px-2" />, */
    4: <i className="fas fa-users-cog fa-fw me-3 text-secondary px-2" />,
    5: <i className="fas fa-users-cog fa-fw me-3 text-info px-2" />,
    6: <i className="fas fa-users-cog fa-fw me-3 text-primary px-2" />,
    7: <i className="fas fa-sync fa-fw me-3 text-primary px-2" />,
    8: <i className="fas fa-database fa-fw me-3 text-primary px-2" />,
    9: <i className="fas fa-database fa-fw me-3 text-primary px-2" />,
  };

  const TITULO = {
    0: "Organización",
    1: "Modulo Personas",
    2: "Modulo Usuarios",
    3: "Unidad Contable",
    /*     4: "Dolar BCV",
    5: "Valor UTE",
    6: "Porcentaje UTE", */
    4: "Gestion de Usuario Web",
    5: "Gestion de Usuario App",
    6: "Estructura Organizativa",
    7: "Sincronización",
    8: "Gestionar Respaldos",
    9: "Gestionar Script",
  };

  const menuclick = (vista) => (e) => {
    setAccconfigene(JSON.parse(localStorage.getItem("accconfigene")));

    e.preventDefault();
    if (vista !== null) {
      setMostrar(vista);
    }

    if (clase === "d-flex bluex-bg") {
      setClase("d-flex bluex-bg toggled");
    } else {
      setClase("d-flex bluex-bg");
    }
  };

  const handleCancelara = () => {
    setMostrar1(false);
  };

  const cancelar = () => {
    setMostrar(0);
    setClase("d-flex bluex-bg");
    props.onHideCancela();
  };

  const catalogoEfiscal = (e) => {
    e.preventDefault();
    setMostrar1(true);
  };

  const SeleccionarEfiscal = (
    idefiscal,
    descrip,
    anio,
    statusorg,
    statuspresup,
    statuspuc,
    statuscat
  ) => {
    setMostrar1(false);
    localStorage.setItem("idefiscal", idefiscal);
    localStorage.setItem("efiscaldes", descrip);
    localStorage.setItem("efiscalanio", anio);
    localStorage.setItem("efiseleccionado", true);
    localStorage.setItem("statuspresup", statuspresup);
    localStorage.setItem("statuspuc", statuspuc);
    localStorage.setItem("statuscat", statuscat);
    localStorage.setItem("statusorg", statusorg);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Configuración General</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>

      <Modal.Body style={{ padding: 0 }}>
        <CambiarEfiscal
          show={mostrar1}
          onHideCancelar={handleCancelara}
          onHideSelectEfis={SeleccionarEfiscal}
        />

        <div
          className={clase}
          id="wrapper"
          style={{ maxHeight: "85vh", overflow: "auto" }}
        >
          <div className="amanecergris " id="sidebar-wrapper">
            <div className="list-group list-group-flush ">
              <div className="list-group list-group-flush">
                <ul className="list-group list-group-light">
                  {ver(accconfigene, 0) && (
                    <li
                      className="list-group-item px-0 p-0 btn-primary"
                      onClick={menuclick(0)}
                      style={estilos}
                    >
                      <a
                        className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                        type="button"
                      >
                        <i className="  fas fa-sitemap fa-fw me-3 text-orange px-2"></i>
                        <span className=" fw-bold">Organizacion</span>
                      </a>
                    </li>
                  )}
                  {ver(accconfigene, 1) && (
                    <li
                      className="list-group-item px-0 p-0 btn-primary"
                      onClick={menuclick(1)}
                      style={estilos}
                    >
                      <a
                        className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                        type="button"
                      >
                        <i className="  fas fa-user-alt fa-fw me-3 text-primary px-2" />
                        <span className=" fw-bold">Personas</span>
                      </a>
                    </li>
                  )}
                  {ver(accconfigene, 2) && (
                    <li
                      className="list-group-item px-0 p-0 btn-primary"
                      onClick={menuclick(2)}
                      style={estilos}
                    >
                      <a
                        className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                        type="button"
                      >
                        <i className="  fas fa-user-check fa-fw me-3 text-success px-2" />
                        <span className=" fw-bold">Usuarios</span>
                      </a>
                    </li>
                  )}
                  {ver(accconfigene, 3) && (
                    <li
                      className="list-group-item px-0 p-0 btn-primary"
                      onClick={menuclick(3)}
                      style={estilos}
                    >
                      <a
                        className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                        type="button"
                      >
                        <i className="  fas fa-university fa-fw me-3 text-info px-2" />
                        <span className=" fw-bold">Unidad Contable</span>
                      </a>
                    </li>
                  )}
                  {/*                   <li
                    className="list-group-item px-0 p-0 btn-primary"
                    onClick={menuclick(4)}
                    style={permisos(4)}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                    >
                      <i className="  fas fa-university fa-fw me-3 text-info px-2" />
                      <span className=" fw-bold">Dolar BCV</span>
                    </a>
                  </li> */}
                  {/*                   <li
                    className="list-group-item px-0 p-0 btn-primary"
                    onClick={menuclick(5)}
                    style={permisos(5)}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                    >
                      <i className="  fas fa-chart-line fa-fw me-3 text-warning px-2" />
                      <span className=" fw-bold">Valor UTE</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item px-0 p-0 btn-primary"
                    onClick={menuclick(6)}
                    style={permisos(6)}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                    >
                      <i className="  fas fa-chart-line fa-fw me-3 text-primary px-2" />
                      <span className=" fw-bold">Porcentaje UTE</span>
                    </a>
                  </li> */}
                  {ver(accconfigene, 4) && (
                    <li
                      className="list-group-item px-0 p-0 btn-primary"
                      onClick={menuclick(4)}
                      style={estilos}
                    >
                      <a
                        className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                        type="button"
                      >
                        <i className="  fas fa-users-cog fa-fw me-3 text-secondary px-2" />
                        <span className=" fw-bold">G. Usuario Web</span>
                      </a>
                    </li>
                  )}
                  {ver(accconfigene, 5) && (
                    <li
                      className="list-group-item px-0 p-0 btn-primary"
                      onClick={menuclick(5)}
                      style={estilos}
                    >
                      <a
                        className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                        type="button"
                      >
                        <i className="  fas fa-users-cog fa-fw me-3 text-info px-2" />
                        <span className=" fw-bold">G. Usuario App</span>
                      </a>
                    </li>
                  )}
                  {ver(accconfigene, 6) && (
                    <li
                      className="list-group-item px-0 p-0 btn-primary"
                      onClick={menuclick(6)}
                      style={estilos}
                    >
                      <a
                        className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                        type="button"
                      >
                        <i className="  fas fa-users-cog fa-fw me-3 text-primary px-2" />
                        <span className=" fw-bold">
                          Estructura Organizativa
                        </span>
                      </a>
                    </li>
                  )}
                  <li
                    className="list-group-item px-0 p-0 btn-primary"
                    onClick={menuclick(7)}
                    style={estilos}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                    >
                      <i className="  fas fa-sync fa-fw me-3 text-primary px-2" />
                      <span className=" fw-bold">Sincronizar</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item px-0 p-0 btn-primary"
                    onClick={menuclick(8)}
                    style={estilos}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                    >
                      <i className="  fas fa-database fa-fw me-3 text-primary px-2" />
                      <span className=" fw-bold">Respaldar</span>
                    </a>
                  </li>
                  <li
                    className="list-group-item px-0 p-0 btn-primary"
                    onClick={menuclick(9)}
                    style={estilos}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                    >
                      <i className="  fas fa-database fa-fw me-3 text-primary px-2" />
                      <span className=" fw-bold">Gestionar Script</span>
                    </a>
                  </li>
                  {ver(accconfigene, 7) && (
                    <li
                      className="list-group-item px-0 p-0 btn-primary"
                      style={estilos}
                    >
                      <a
                        className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                        type="button"
                        onClick={catalogoEfiscal}
                      >
                        <i className="  fas fa-tags fa-fw me-3 redlater-text px-2" />
                        <span className=" fw-bold">
                          Cambiar Ejercicio Fiscal
                        </span>
                      </a>
                    </li>
                  )}
                  <li
                    className="list-group-item px-0 p-0 bg-transparent"
                    style={estilos}
                  >
                    <a
                      className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                      type="button"
                      onClick={cancelar}
                    >
                      <i className="  fas fa-power-off fa-fw me-3 text-danger px-2" />
                      <span className=" fw-bold">Salir</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div id="page-content-wrapper">
            <nav
              className="navbar navbar-expand-lg navbar-light py-2 px-2"
              id="one"
              style={{ background: "none" }}
            >
              <div className="d-flex align-items-center">
                <i
                  className="fas fa-align-left  text-dark fs-4 me-3"
                  onClick={menuclick(null)}
                  id="menu-toggle"
                />
              </div>
              <div
                className="collapse navbar-collapse dropstart"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav mx-auto text-center">
                  <h4 className="fs-4">
                    {ICONO[mostrar]} {TITULO[mostrar]}
                  </h4>
                </ul>
              </div>
            </nav>

            <div className="container-fluid mx-auto py-3 px-0 m-0" id="scrolty">
              {VISTA[mostrar]}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/modalVerConfiguracion.js